module.exports = __webpack_public_path__ + "media/images/icons/collapse-up-b689dc1fe0b2728501a528287c0db869.svg";